var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.756,
    height: 23.68,
    viewBox: "0 0 23.756 23.68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Search",
    d: "M452.626-244.645c.365.052.731.09,1.093.157a8.9,8.9,0,0,1,4.945,2.662,8.86,8.86,0,0,1,2.38,4.711,9.041,9.041,0,0,1-1.076,6.161c-.042.074-.079.149-.138.26a1.651,1.651,0,0,1,.172.13q2.979,2.883,5.956,5.769a2.193,2.193,0,0,1,.309,2.911,2.105,2.105,0,0,1-3.158.365c-1.279-1.2-2.525-2.437-3.784-3.659-.8-.772-1.594-1.541-2.381-2.32a.283.283,0,0,0-.412-.062,8.643,8.643,0,0,1-3.377,1.1,8.985,8.985,0,0,1-6.657-1.811,8.922,8.922,0,0,1-3.483-5.953c-.036-.24-.059-.481-.088-.722v-1.148a.785.785,0,0,0,.032-.131,8.832,8.832,0,0,1,1.394-4.193,8.946,8.946,0,0,1,6.073-4.074c.348-.066.7-.1,1.052-.153Zm4.9,9.125a5.5,5.5,0,0,0-5.455-5.456,5.486,5.486,0,0,0-5.47,5.455,5.488,5.488,0,0,0,5.468,5.458A5.5,5.5,0,0,0,457.526-235.52Z",
    transform: "translate(-442.927 244.645)",
    fill: "#999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileSearch);
export default __webpack_public_path__ + "static/media/mobile-search.7a4785a5017a158ef53806bcfbd4f93f.svg";
export { ForwardRef as ReactComponent };